import React, { useEffect } from "react";
import AddProductPage from "../../../Components/Dashboard/AdminAllPage/AddProducts/AddProducts";
import ConsultationForm from "../../../Components/Form/ConsultationForm";

const MiraiConsultation = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when component mounts
  }, []);
  return (
    <div className="lg:py-20 sm:py-5 min-h-screen border-t border-blue-200">
      <div className="w-full  max-w-screen-2xl mx-auto p-4 ">
        <h1 className="lg:text-5xl sm:text-2xl font-semibold font-jost customBlue">
           Get free consultation
        </h1>
        <p className="mt-4 font-jost lg:text-4xl sm:text-lg text-blue-900 lg:mb-4 sm:mb-1">Application Form</p>
         <ConsultationForm></ConsultationForm>
      </div>
    </div>
  );
};

export default MiraiConsultation;
